import templateUrl from './alert.html';

export default {
  templateUrl,
  bindings: {
    alerts: '<',
    onAlertClicked: '&'
  },
  controller: class AlertComponent {
    constructor($state, AuthService, EventEmitter) {
      'ngInject';

      Object.assign(this, { $state, AuthService, EventEmitter });
    }

    alertClicked(alert) {
      this.onAlertClicked(
        this.EventEmitter({
          alert
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/alert/alert.component.js